const Api = {
	matchAdminLogin: 'admin/matchAdminLogin',
	logout: 'admin/logout',
    resourceClassList:'admin/resourceClassList',
	resourceClassAdd:'admin/resourceClassAdd',
	resourceClassEdit:'admin/resourceClassEdit',
	resourceClassDel:'admin/resourceClassDel',
	resourceTypeList: 'admin/resourceTypeList',
	resourceList: 'admin/resourceList',
	uploadFile: 'admin/uploadFile',
	saveResource: 'admin/saveResource',
	resourceDelete: 'admin/resourceDelete',
	editSave: 'admin/editSave',
	delFile: 'admin/delFile',
	download: 'admin/download',
	createCourse: 'admin/saveCourse',
	courses: 'admin/courses',
	courseContent: 'admin/courseinfo',
	deletecourse: 'admin/deletecourse',
	courserType: 'admin/courseTypeList',
	checkToken: 'admin/checkToken',
    JdStudentLogin: 'admin/JdStudentLogin',
	courseinfo: 'admin/courseinfo',
	blackBbUrl: 'blackboard',
	mindMapUrl: 'mindmap',
	teacherLogin: 'admin/matchTeacherLogin',
	addSchool: 'school/addSchool',
	showSchool: 'school/showSchool',
	saveSchool: 'school/saveSchool',
	delSchool: 'school/delSchool',
	adminShowSchool: 'admin/showSchool',
	showAdmin: 'admin/showAdmin',
	addAdmin: 'admin/addAdmin',
	saveAdmin: 'admin/saveAdmin',
	schoolList: 'admin/schoolList',
	delAdmin: 'admin/delAdmin',
	showTeacher: 'teacher/showTeacher',
	addTeacher: 'teacher/addTeacher',
	saveTeacher: 'teacher/saveTeacher',
	delTeacher: 'teacher/delTeacher',
	resetPwd: 'teacher/resetPwd',
	showStudent: 'jd/showStudent',
	showClass: 'jd/showClass',
	// addStudent: 'student/addStudent',
	saveStudent: 'jd/saveStudent',
	delStudent: 'jd/delStudent',
	resetStuPwd: 'jd/resetStuPwd',
	resetAdminPwd: 'admin/resetPwd',
	bj_sx: 'student/bj_sx',
    cl_list: 'jd/cl_list',
	delClass: 'jd/delClass',
	saveClass: 'jd/saveClass',
    statistics: 'jd/statistics',
	addClass: 'class/addClass',
	getCourseProgressList: 'jd/getCourseProgressList',
    getTeacherCourseByClass: 'jd/getTeacherCourseByClass',
	startCourse: 'jd/startCourse',
	endingCourse: 'jd/endingCourse',
    stuSignIn: 'jd/stuSignIn',
	showTag: 'exam/showTag',
	updTag: 'exam/updTag',
	addTag: 'exam/addTag',
	updSaveTag: 'exam/updSaveTag',
	delTag: 'exam/delTag',
	delTopic: 'exam/delTopic',
	showTopic: 'exam/showTopic',
	getClassRecord: 'jd/getClassRecord',
	showSignInList: 'jd/showSignInList',
    show_tag: 'exam/show_tag',
    addTopic: 'exam/addTopic',
    updTopic: 'exam/updTopic',
    updSaveTopic: 'exam/updSaveTopic',
	teacherIssueQuiz: 'jd/teacherIssueQuiz',
	screenTestPaper: 'exam/screenTestPaper',
	deleteTestPaper: 'exam/deleteTestPaper',
	saveTestPaper: 'exam/saveTestPaper',
	setIncTopic: 'exam/setIncTopic',
	findTestPaper: 'exam/findTestPaper',
    showSx: 'jd/showSx',
	showPaperContent: 'jd/showPaperContent',
	showClassSignIn: 'jd/showClassSignIn',
	studentSubmitTest: 'jd/studentSubmitTest',
	getQuizList: 'jd/getQuizList',
	seeStudentQuizList: 'jd/seeStudentQuizList',
    saveSx: 'jd/saveSx',
    deleteSx: 'jd/deleteSx',
    findBySx: 'jd/findBySx',
    showStuSxList: 'jd/showStuSxList',
    showCourseScreenList: 'jd/showCourseScreenList',
    stuPutSx: 'jd/stuPutSx',
	exmapapers: 'exam/exmapapers',
	getRecordList: 'jd/getRecordList',
	seeUnapprovedStudentQuiz: 'jd/seeUnapprovedStudentQuiz',
	TeacherCheckAskAnswer: 'jd/TeacherCheckAskAnswer',
	seeStudentQuiz: 'jd/seeStudentQuiz',
    showDiscussList: 'jd/showDiscussList',
    showDiscussNums: 'jd/showDiscussNums',
	uploadKindeditor: 'admin/uploadKindeditor',
    bindClient: 'jd/bindClient',
    sendMessage: 'jd/sendMessage',
	newsWeUpload: 'news/weimg',
	pdfPreview: 'pdf/',
	newsUpload: 'news/upload',
	newsDesImg: 'news/desimg',
	newsAdd: 'news/add',
	newsList: 'news/list',
	newsDel: 'news/del',
	newsInfo: 'news/info',
	bannerList: 'banner/list',
	bannerUpload: 'banner/upload',
	bannerAdd: 'banner/add',
	bannerDel: 'banner/del',
	import: 'tools/import',
	excelTemplateUrl: 'uploads/excel/template/template.xlsx',
	divideClass: 'admin/divideClass',
	schoolInfo: 'school/editSchool',
	getExcel: 'exam/getExcel',
    app_showApp: 'app/showApp',
    app_saveApp: 'app/saveApp',
    app_delApp: 'app/delApp',
	materialTypeList: 'admin/materialTypeList',
	saveProject: 'project/saveProject',
	uploadProjectFile: 'project/uploadFile',
	AdminProjectList: 'project/AdminProjectList',
	addProjectResource: 'project/addProjectResource',
	delProjectResource: 'project/delProjectResource',
	checkProjectName: 'project/issetName',
	getMatingTypeList: 'project/materialTypeList',
	delProject: 'project/delProject',
	getProjectDetail: 'project/projectDetail',
	getCourseList: 'project/courseList',
	getResource: 'project/getResource',
    project_AdminProjectList: 'project/AdminProjectList',
    admin_allocationProject: 'admin/allocationProject',
    admin_allocationAppCenter: 'admin/allocationAppCenter',
    admin_courseLists: 'admin/courseLists',
    admin_sclAdminCourseList: 'admin/sclAdminCourseList',
    meterial_mtlTypeList: 'meterial/mtlTypeList',
    meterial_uploadFile: 'meterial/uploadFile',
    meterial_saveMeterial: 'meterial/saveMeterial',
    meterial_showMeterialList: 'meterial/showMeterialList',
	admin_showTeaCourse: 'admin/showTeaCourse',
	showTeaCourse:'admin/showTeaCourse',
    school_allocationCourseToTea: 'school/allocationCourseToTea',
    teacher_editTeacher: 'teacher/editTeacher',
	jd_getTeacherCourseOne: 'jd/getTeacherCourseOne',
	getCourseCustom: 'course/getCourseCustom',
    project_projectList: 'project/projectList',
	project_projectListNoPage: 'project/projectListNoPage',
    project_dianZan: 'project/dianZan',
    course_putDrillData: 'course/putDrillData',
    drill_showDrillList: 'drill/showDrillList',
    drill_putDrillData: 'drill/putDrillData',
    drill_showStuPutDrillList: 'drill/showStuPutDrillList',
	course_getcoursecustom: 'course/getCourseCustom',
	saveCourseCustom: 'course/saveCourseCustom',
    drill_teaCommentStuDrill: 'drill/teaCommentStuDrill',
    drill_issuedDrill: 'drill/issuedDrill',
    drill_delDrill: 'drill/delDrill',
    drill_showProjectPutData: 'drill/showProjectPutData',
	getAllocation: 'meterial/getAllocationApp',
	delMeterial: 'meterial/delMeterial',
    jd_delQuiz: 'jd/delQuiz',
    jd_getStuSignInDetails: 'jd/getStuSignInDetails',
	jd_getStuInfo: 'jd/getStuInfo',
    jd_getStuQuizDetails: 'jd/getStuQuizDetails',
    jd_getStuSxDetails: 'jd/getStuSxDetails',
	contents_uploads: 'contents/uploads',
	contents_saveCourseHome: 'contents/saveCourseHome',
	course_getCourseTemp: 'course/getCourseTemp',
	contents_showCourseContent: 'contents/showCourseContent',
	course_saveCourseTemp:'course/saveCourseTemp',
	course_delCourseTemp:'course/delCourseTemp',
    courseware_uploadWareFiles: 'courseware/uploadWareFiles',
    courseware_saveCourseWare: 'courseware/saveCourseWare',
	courseware_saveCourseWares:"courseware/saveCourseWares",
    courseware_showCourseWare: 'courseware/showCourseWare',
    admin_uploadsClassifyImg: 'admin/uploadsClassifyImg',
    admin_projectClassList: 'admin/projectClassList',
	project_tinyimgupload: 'project/tinyImgUpload',
    courseware_delCourseWare: 'courseware/delCourseWare',
	exam_topictemplate: 'exam/topictemplate',
  	examExportTopic: 'exam/exportTopic',
	resourceBatchDelete:'admin/resourceBatchDelete',
	adminGetCourseList:"admin/getCourseList",
	adminGetExamList:"admin/getExamList",
	adminGetShixunList:"admin/getShixunList",
	adminAnalysisGrade:"admin/analysisGrade",
	adminAnalysisData:"admin/analysisData",
	adminTrainChartData:"admin/trainChartData",
	adminSignChartData:"admin/signChartData",
	jdSaveClass:"jd/saveClass",
	teacherEditTeacher:"teacher/editTeacher",
	teacherSaveTeacher:"/teacher/saveTeacher",
	jdWsBind:"jd/ws/bind",
	jdActivitiesAdd:"jd/activities/add",
	jdActivities:"jd/activities",
	jdActivitiesDel:"jd/activities/del",
	jdActivitiesStop:"jd/activities/stop",
	jdTActivitiesSelect_personRand:"jd/t/activities/select_person/rand",
	jdTActivitiesSelect_personReset:"jd/t/activities/select_person/reset",
	jdTActivitiesCheckinInfo:"jd/t/activities/checkin/info",
	jdTActivitiesAnswer_recordInfo:"jd/t/activities/answer_record/info",
	literacy_rules: "jd/quality/abilityList", // 素养细则
	save_literacy_rules: "jd/quality/saveAbility", // 保存素养细则
	delete_literacy_rules: "jd/quality/deleteAbility", // 删除素养细则
	literacy_score: "jd/quality/scoring", // 评定分数
	literacy_score_detail: "jd/quality/scoreDetail", // 评定详情
	literacy_student_score_detail: "jd/quality/studentScoreDetail", // 学生素质评定详情
	literacy_student_list: "jd/quality/studentList", // 素质评定学生列表
	training_assessment_list: "jd/training/assessmentList", // 技能评价列表	
	video_category: "jd/video/getVideoCategory", // 热门视频分类
	video_list: "jd/video/getHotVideoList", // 热门视频列表
	video_summary: "jd/video/videoSummary", // 视频顶部概述内容
	ranking_author: "jd/video/author", // 博主详细信息
	video_person_analysis: "jd/video/videoPerson", // 视频观众分析
	video_bash_analysis: "jd/video/getVideoBashAnalysis", // 视频基础数据分析
	video_bash_play_analysis: "jd/video/getVideoBashPlay", // 视频基础数据分析-播放量
	training_detail: "jd/training/detail", // 实训详情
	training_upload: "jd/training/stuUploadFile", // 上传文件
	training_submit: "jd/training/stuSubmit", // 实训提交
	jdCourseScoreRatio:"jd/Course/scoreRatio",//权重设置
	jdCourseScoreRatioInfo:"jd/Course/scoreRatioInfo",//权重详情
	jdClassCoverList:"/jd/classCoverList",//备选封面
	jdCoursePush:"jd/Course/push",//章节推送
	training_assessment_detail: "jd/training/assessmentDetail", // 技能评价详情
	training_end: "jd/training/endTraining", // 结束实训
	training_score: "jd/training/score", // 实训-教师评分
	training_back_redoing: "jd/training/backRedoing", // 实训-打回重做
	jdCourseSaveSelectionClass:"jd/Course/saveSelectionClass", //班级选择
	jdCourseSelectionClassInfo:"jd/Course/selectionClassInfo", //班级选择详情
	jdSActivitiesCheckinCheckin:"jd/s/activities/checkin/checkin",//学生签到
	jdSActivitiesCheckinInfo:"jd/s/activities/checkin/info",//学生签到详情
	jdSActivitiesAnswer_recordAnswer:"jd/s/activities/answer_record/answer",//学生抢答
	jdSActivitiesAnswer_recordInfo:"jd/s/activities/answer_record/info",//学生抢答详情
	jdSActivitiesSelect_personInfo:"jd/s/activities/select_person/info",//学生端选人详情
	jdTActivitiesSelect_personInfo:"jd/t/activities/select_person/info",//教师端选人详情
	jdCourseSelectionClassInfo:"jd/Course/selectionClassInfo", //班级选择详情
	view_course: "jd/viewCourse", // 学生课程观看时长
	jdTActivitiesVoteInfo:"jd/t/activities/vote/info",//教师投票详情
	jdSActivitiesVoteInfo:"jd/s/activities/vote/info",//学生投票详情
	jdSActivitiesVoteAddVote:"jd/s/activities/vote/addVote",
	discuss_list: "jd/activities/discuss/list", // 讨论详情
	discuss_add: "jd/activities/discuss/add", // 回复讨论内容
	discuss_like: "jd/activities/discuss/like", // 点赞回复
	discuss_delete: "jd/activities/discuss/del", // 删除回复
	discuss_edit: "jd/activities/discuss/edit", // 编辑回复
	discuss_top: "jd/t/activities/discuss/top", // 置顶-取消置顶
	data_evaluation_index: "jd/synthesize_evaluation/index", // 综合数据评价-班级数据魔方
	jdSActivitiesVoteAddVote:"jd/s/activities/vote/addVote",
	jdJoinClass:"jd/joinClass",//加入班级 邀请码
	jdCourseRankingHero_ranking:"/jd/CourseRanking/hero_ranking",//英雄榜
	jdCourseRankingGetRanking:"/jd/CourseRanking/getRanking",//排行榜
	evaluation_quality_list: "jd/synthesize_evaluation/quality_list", // 素养考核列表
	evaluation_quality_detail: "jd/synthesize_evaluation/quality_detail", // 素养考核详情
	jdCourseMenuInfo:"jd/Course/menuInfo",//章节锁定详情
	jdCourseSaveMenu:"jd/Course/saveMenu",//保存章节状态
	evaluation_training_list: "jd/synthesize_evaluation/training_list", // 技能考核列表
	evaluation_training_project: "jd/synthesize_evaluation/training_project", // 技能考核-项目列表
	evaluation_attitude_list: "jd/synthesize_evaluation/attitude_list", // 态度考核列表
	evaluation_attitude_detail: "jd/synthesize_evaluation/attitude_detail", // 态度考核详情
	evaluation_knowledge_paper_list: "jd/synthesize_evaluation/knowledge_paper_list", // 知识考核-试卷列表
	evaluation_knowledge_statistics: "jd/synthesize_evaluation/knowledge_statistics", // 知识考核-班级统计
	evaluation_knowledge_list: "jd/synthesize_evaluation/knowledge_list", // 知识考核-个人排名
	jdSaveStudent:"jd/saveStudent",//学生 个人中心
	jdFindStudent:"jd/findStudent",//学生
	evaluation_exam_list: "jd/synthesize_evaluation/quiz_list", // 考试成绩列表
	evaluation_paper_list: "jd/synthesize_evaluation/quiz_paper_list", // 考试试卷列表-学生分数
	evaluation_answer_detail: "jd/synthesize_evaluation/knowledge_answer_detail", // 知识考核-答题详情
	jdCourseClList:"jd/courseClList",//班级列表
	jd_goods_video_list: "jd/goods_video/video_list", // 电商视频列表
	jd_goods_video_detail: "jd/goods_video/video_detail", // 电商视频详情
	showStuDirllDetail: "drill/showStuPutDrillDetail", // 详情
	jdTrainingStuTopicList:"jd/training/stuTopicList",//项目实训题目详情
	jdTrainingStuSaveAnswer:"jd/training/stuSaveAnswer",
	jdTrainingStuSubmitAnswer:"jd/training/stuSubmitAnswer",
	jdTrainingGetStuTopicDetail:"jd/training/getStuTopicDetail",
	jdTrainingTeacherScore:"jd/training/TeacherScore",
	jdTrainingRepeat:"jd/training/repeat",
	jdTrainingTeacherScoreNextStuId:"jd/training/teacherScoreNextStuId"

}

export default Api;
